import { Route } from "@angular/router";
import { MsalRedirectComponent } from "@azure/msal-angular";

export const authRedirectRoutes: Route[] = [
    {
        path: 'auth',
        component: MsalRedirectComponent
    }
];
